module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENERAL")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre3"
    }
  }, [_vm._v("V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLUME")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DITOR")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XPOSITION")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOK")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OB")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TRACTATES ON THE PROPHETS HOSEA, JOEL, AND AMOS")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ON")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROPHET")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSEA")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ON")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROPHET")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OEL")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ON")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROPHET")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MOS")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IBLIOGRAPHY")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENERAL")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDEX")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CRIPTURE")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDEX")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTES")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BOUT")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTHOR")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/fin_acheve",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITLES")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FROM")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTER")]), _vm._v("V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARSITY")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RESS")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 63
// module chunks = 0